<template>
    <div class="plotly-print-guard">
        <v-hover v-if="showExport&&!mobileMode">
            <div slot-scope="{ hover }" class="caption grey--text">
                <v-layout style="min-height:40px;">
                    <v-btn @click="dialog=true" outline small icon flat round class="grey--text" ma-0 pa-0 v-if="layout.carnotDescription&&layout.carnotDescription!==''">
                        <v-icon small>
                            fa-info
                        </v-icon>
                    </v-btn>
                    <v-dialog v-model="dialog" max-width="500" v-if="layout.carnotDescription&&layout.carnotDescription!==''">
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{ layout.title }}
                            </v-card-title>
                            <v-card-text>
                                <p>{{ layout.carnotDescription }}</p>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <span v-show="hover" ma-0 pa-0>
                          <v-btn @click="downloadWithCSS" outline small flat round class="grey--text" ma-0 pa-0>
                              {{'Export as PDF'|translate}}
                          </v-btn>
                          <v-btn @click="downloadCSV" outline small flat round class="grey--text" ma-0 pa-0>
                              {{'Download CSV'|translate}}
                          </v-btn>
                      </span>
                </v-layout>
            </div>
        </v-hover>
        <Plotly ref="container" class="vue-plotly" :data="data" :layout="alteredLayout" :options="options" :to-image-button-options="imageOpts" :display-mode-bar="displayModeBar"></Plotly>
    </div>
</template>
<script>
    const events = [
        'click',
        'hover',
        'unhover',
        'selecting',
        'selected',
        'restyle',
        'relayout',
        'autosize',
        'deselect',
        'doubleclick',
        'redraw',
        'animated',
        'afterplot'
    ]
    import {Plotly} from 'vue-plotly'
    import jsPDF from 'jspdf'
    import defaults from 'lodash/defaults'
    import {exportCSVFromDicts} from "@/tocsv.js"
    export default {
        components: {Plotly},
        data() {
            return {
                printOverride: false,
                dialog:false,
                imageOpts:{
                    format: 'png',
                    width: null,
                    height: null,
                }
            }
        },
        props: {
            showExport: {type: Boolean, default: false},
            whiteMode: {type: Boolean, default: false},
            options: {
                type: Object
            },
            data: {
                type: Array
            },
            layout: {
                type: Object
            }
        },
        computed: {
            mobileMode(){
                return process.env.VUE_APP_MOBILE_MODE ? process.env.VUE_APP_MOBILE_MODE : false
            },
            alteredLayout() {
                let fixedl=JSON.parse(JSON.stringify({
                    ...this.layout,
                    paper_bgcolor: process.env.VUE_APP_THEME == 'dark'&&!this.printOverride&&!this.whiteMode ? 'rgba(0,0,0,0)' : null,
                    font: process.env.VUE_APP_THEME == 'dark'&&!this.printOverride&&!this.whiteMode  ? {
                        color: "#FFFFFF"
                    } : {
                        color: "#424242"
                    }
                }))
                if(process.env.VUE_APP_THEME == 'dark'&&!this.whiteMode){
                    if(!fixedl.plot_bgcolor&&!this.printOverride ){
                        fixedl.plot_bgcolor='rgba(0,0,0,0)'
                    }
                    if(fixedl.xaxis&&!this.printOverride){
                        fixedl.xaxis.gridcolor = 'rgba(255,255,255,0.1)'
                        fixedl.xaxis.gridwidth = 1
                    }
                    if(fixedl.yaxis&&!this.printOverride){
                        fixedl.yaxis.gridcolor = 'rgba(255,255,255,0.1)'
                        fixedl.yaxis.gridwidth = 1
                    }
                }
                if(fixedl.annotations&&fixedl.annotations.length>0&&(this.whiteMode||this.printOverride||process.env.VUE_APP_THEME !== 'dark')){
                    for (let annotation of fixedl.annotations){
                        annotation.arrowcolor="#424242"
                    }
                }
                if (this.data&&this.data.length>0&&this.data.filter(x=>x.type&&(x.type==="scatterpolar"||x.type==="barpolar")).length>0){
                    fixedl.polar={
                        barmode: fixedl.barmode,
                        radialaxis:{
                            visible: true,
                        },
                    }
                    if(process.env.VUE_APP_THEME == 'dark'&&!this.whiteMode){
                        fixedl.polar.bgcolor='rgba(0,0,0,0)'
                        fixedl.polar.radialaxis.color="#FFFFFF"
                    }
                }
                return JSON.parse(JSON.stringify(fixedl))
            },
            displayModeBar(){
                if (this.mobileMode){
                    return false
                }
                else if(this.options&&Object.keys(this.options).includes("displayModeBar")){
                    return this.options.displayModeBar
                } else {
                    return 'hover'
                }
            }
        },
        mounted(){
            this.initEvents()
        },
        methods: {
            initEvents() {

                this.__generalListeners = events.map((eventName) => {
                    return {
                        fullName: 'plotly_' + eventName,
                        handler: (...args) => {
                            this.$emit.apply(this, [eventName].concat(args))
                        }
                    }
                })

                this.__generalListeners.forEach((obj) => {
                    this.$refs.container.$el.on(obj.fullName, obj.handler)
                })
            },
            getPercentages(array) {
                let sum = array.reduce((sum, x) => sum + x);
                return array.map(x => ((x / sum) * 100).toFixed(2))
            },
            downloadCSV() {
                let df = {};
                if (this.data.length > 1) {
                    let col1 = "Time";
                    if (this.layout && this.layout.xaxis && this.layout.xaxis.title) {
                        col1 = this.layout.xaxis.title.text;
                    }
                    if (this.data[0].x[0] === this.data[1].x[0] && this.data[0].x.length === this.data[1].x.length) {
                        for (let item of this.data) {
                            if (!df[col1]) {
                                df[col1] = item.x;
                            }
                            df[item.name] = item.y
                            if (item.hovertext && !item.timestamp) {
                                df["Time"] = item.hovertext
                            }
                        }

                        exportCSVFromDicts(df)
                    } else {
                        for (let item of this.data) {
                            let df = {};
                            df[col1] = item.x;
                            df[item.name] = item.y
                            if (item.hovertext && !item.timestamp) {
                                df["Time"] = item.hovertext
                            }
                            exportCSVFromDicts(df)
                        }

                    }

                } else if (this.data[0].type === "pie") {
                    df["Labels"] = this.data[0].labels
                    df["Values"] = this.data[0].values
                    df["Percentages"] = this.getPercentages(this.data[0].values)
                    exportCSVFromDicts(df)
                } else if (this.data[0].type === "table") {
                    for (let key in this.data[0].header.values){
                        df[this.data[0].header.values[key].toString().replace("<b>","").replace("</b>","")]=this.data[0].cells.values[key]
                    }
                    exportCSVFromDicts(df)
                }else if (this.data[0].type === "heatmap") {
                    df["Time"]=this.data[0].x
                    for (let key in this.data[0].y){
                        df[this.data[0].y[key]]=this.data[0].z[key]
                    }
                    exportCSVFromDicts(df)
                } else {
                    let col1 = "Time";
                    let col2 = "Value"
                    if (this.layout && this.layout.xaxis && this.layout.xaxis.title) {
                        col1 = this.layout.xaxis.title.text;
                    }
                    if (this.layout && this.layout.yaxis && this.layout.yaxis.title) {
                        col2 = this.layout.yaxis.title.text;
                    }
                    df[col1] = this.data[0].x
                    df[col2] = this.data[0].y
                    exportCSVFromDicts(df)
                }
            },
            async toImage(options) {
                this.printOverride=true
                await this.sleep(100)
                let opts = defaults(options, {
                    format: 'png',
                    width: this.$refs.container.$el.clientWidth,
                    height: this.$refs.container.$el.clientHeight,
                })
                let img=this.$refs.container.toImage(opts)
                this.printOverride=false
                return img
            },
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            async downloadWithCSS() {
                this.printOverride=true
                await this.sleep(100)
                let doc = new jsPDF('', 'pt', 'a4',true);
                let img = null
                img = await this.toImage()
                doc.addImage(img, 'PNG', 30, 30,
                    1.0 * 535.28,
                    1.0 * 535.28 / this.$refs.container.$el.clientWidth * this.$refs.container.$el.clientHeight,"","FAST"
                )
                doc.save("export.pdf")
                this.printOverride=false
            },
        }
    }
</script>
<style>
    @media print {
        .plotly-print-guard {
            page-break-inside: avoid !important;
        }
    }
    @media not print {
        g.parcoords text{
            text-shadow: none !important;
        }
    }
</style>
